module.exports = __webpack_public_path__ + "img/36vsTMC.5b778fe8.png";